// src/store/hotelOffersSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getHotelOffers } from '../../services/hotel/hotelServices';



export const fetchHotelOffers = createAsyncThunk(
    'hotelOffers/fetchHotelOffers',
    async () => {
        const data = await getHotelOffers();
        return data;
    }
);

const hotelOffersSlice = createSlice({
    name: 'hotelOffers',
    initialState: {
        offers: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchHotelOffers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchHotelOffers.fulfilled, (state, action) => {
                state.offers = action.payload;
                state.loading = false;
            })
            .addCase(fetchHotelOffers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default hotelOffersSlice.reducer;
